"use strict";

import BaseEditController from "dias/ui/formsteps/formstepBaseEdit.controller.js";


class AstorgEditSperrungController extends BaseEditController {
  /*@ngInject*/
  constructor($q, $scope, DiasNotification) {
    super($q, $scope, DiasNotification);

    this.save = () => {
      return $scope.model.updateSperrung(this.model.ast_gesperrt, this.model.ast_sperrbemerkung).then(
        () => {
          $scope.model.merge($scope.model, this.model);
        },
        // this.onError
        errors => {
          const errorsLabel = {
            ast_gesperrt: "Gesperrt: ",
            ast_sperrbemerkung: "Sperrbemerkung: "
          };
          return this.onErrors(errors, errorsLabel);
        }
      );
    };
  }
}

export default AstorgEditSperrungController;
